import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'

import type Field from 'modules/reports/store/models/Field'

import { LabelType } from '../../FieldSelector'
import Label from '../../FieldSelector/Label'

interface Props {
  currentGroupBy: Field[]
  label: LabelType
  clear: () => void
  children: React.ReactNode[]
}

const Aggregations = ({ currentGroupBy, label, clear, children }: Props) => {
  return (
    <FormRow>
      <Label optional={label.optional} tooltipText={label.tooltipText} text={label.text} />

      <Box
        borderRadius={{
          all: 'abs004',
        }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'radicalRed200',
          },
        }}
        padding="s12"
      >
        <Box
          borderRadius={{
            all: 'abs008',
          }}
          background={'grey200'}
        >
          <Box padding="s8" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
            <Box gap="s4" flexDirection="row" alignItems="center">
              <Box paddingLeft={'s16'}>
                <Text.Normal weight="medium" size="200" color="grey1000" lineClamp={2}>
                  {currentGroupBy.map((groupBy) => groupBy.get('label')).join(', ')}
                </Text.Normal>
              </Box>
            </Box>

            <Box
              cursor="pointer"
              onClick={() => {
                clear()
              }}
              flexDirection="row"
              alignItems="center"
              gap="s4"
            >
              <Icon.Medium icon="delete" color="grey600" />
            </Box>
          </Box>
          <Box background="grey100" padding="s8">
            {children}
          </Box>
        </Box>
      </Box>
    </FormRow>
  )
}

export default Aggregations
